import React from 'react';

import { RHFSelect } from '@/Components/shadcn/rhf-select';
import UIStrings from '@/Utils/UIStrings';
import employmentTypeOptions from './employmentTypeOptions';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';

function EmploymentType(): React.JSX.Element {
    const options = employmentTypeOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.EmploymentType}*`}
            name={JobDetailsFieldTypes.EmploymentType}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.EmploymentType}
        />
    );
}

export default EmploymentType;
